import React from 'react';
import {AvForm} from 'availity-reactstrap-validation';
import {Fieldset} from "primereact/fieldset";
import OrderService from "../../shared/service/OrderService";
import OrderItemsForKitchenColumn from "../../shared/component/dataTable/columns/OrderItemsForKitchenColumn.json";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import Dialog from "../../shared/component/dialog/Dialog";
import DataTable from "../../shared/component/dataTable/DataTable";
import DataTableAll from "../../shared/component/dataTable/DataTableAll";

export default class OrdersKitchen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orderList: [],
            displayDialog: false,
            selectedOrder: null,
        };
        this.orderService = new OrderService();
    }

    componentDidMount() {
        this.getNewOrders();

        // 5 saniyede bir sorguyu tekrar çek
        this.orderInterval = setInterval(() => {
            this.getNewOrders();
        }, 5000); // 5000 ms = 5 saniye
    }

    componentWillUnmount() {
        // Component unmount olduğunda interval'i temizle
        clearInterval(this.orderInterval);
    }


    getNewOrders() {
        this.orderService.getOrdersForKitchen().then(response => {
            if (GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({orderList: response});
            }
        });
    }

    render() {
        return (
            <div>
                <AvForm>
                    {this.newOrderList()}
                </AvForm>
            </div>
        );
    }

    newOrderList() {
        const {orderList, selectedOrder, displayDialog} = this.state;

        return (
            <>
                <style>
                    {`
                        .blinking-badge {
                            animation: blink 1.2s step-start infinite;
                        }

                        @keyframes blink {
                            0% { opacity: 1; }
                            50% { opacity: 0.4; }
                            100% { opacity: 1; }
                        }

                        .scroll-wrapper {
                            max-height: 85vh;
                            overflow-y: auto;
                            padding-right: 8px;
                        }
                    `}
                </style>

                <Fieldset legend="Kitchen Display">
                    <div className="scroll-wrapper">
                        <div
                            style={{
                                display: 'grid',
                                gridTemplateColumns: `repeat(4, 1fr)`,
                                gap: '12px',
                                padding: '8px',
                            }}
                        >
                            {orderList.map((order) => {
                                const isWEB = order.orderNo.startsWith("WEB");
                                const displayOrderNo = isWEB ? order.orderNo : `TILL-${order.orderNo}`;

                                let backgroundColor = '#E5E7EB';
                                let badgeText = '';
                                let badgeStyle = {};

                                if (order.orderStatus === "ORDER_ACCEPTED") {
                                    backgroundColor = '#F59E0B'; // Amber 500
                                    badgeText = 'READY';
                                    badgeStyle = {
                                        backgroundColor: '#D97706', // Amber 600
                                        animationClass: '',
                                    };
                                } else if (order.orderStatus === "ORDER_PREPARING") {
                                    backgroundColor = '#3B82F6';
                                    badgeText = 'PREPARING';
                                    badgeStyle = {
                                        backgroundColor: '#2563EB',
                                        animationClass: '',
                                    };
                                }
                                else if (order.orderStatus === "ORDER_READY") {

                                    backgroundColor = '#10B981';
                                    badgeText = 'NEW';
                                    badgeStyle = {
                                        backgroundColor: '#16A34A',
                                        animationClass: 'blinking-badge',
                                    };
                                }


                                return (
                                    <div
                                        key={order.orderNo}
                                        style={{
                                            backgroundColor,
                                            color: 'white',
                                            borderRadius: '10px',
                                            padding: '12px',
                                            boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            position: 'relative',
                                            minHeight: '310px',
                                            fontSize: '14px',
                                            justifyContent: 'space-between',
                                        }}
                                    >
                                        {badgeText && (
                                            <div style={{
                                                position: 'absolute',
                                                top: '12px',
                                                right: '12px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px'
                                            }}>
                                                {isWEB && (
                                                    <div style={{
                                                        backgroundColor: badgeStyle.backgroundColor,
                                                        color: 'white',
                                                        fontWeight: 'bold',
                                                        padding: '4px 10px',
                                                        borderRadius: '8px',
                                                        fontSize: '18px',
                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        height: '32px',
                                                        minWidth: '32px'
                                                    }}>
                                                        <span className="pi pi-cloud"></span>

                                                    </div>
                                                )}
                                                <div className={badgeStyle.animationClass} style={{
                                                    backgroundColor: badgeStyle.backgroundColor,
                                                    color: 'white',
                                                    fontWeight: 'bold',
                                                    padding: '4px 10px',
                                                    borderRadius: '8px',
                                                    fontSize: '18px',
                                                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}>
                                                    {badgeText}
                                                </div>
                                            </div>
                                        )}





                                        <div>
                                            <div>
                                                {/* Order No + Order Type */}
                                                <div style={{
                                                    fontWeight: 'bold',
                                                    fontSize: '14px',
                                                    marginBottom: '4px',
                                                    color: isWEB ? 'white' : 'white'
                                                }}>
                                                    {displayOrderNo} ({order.orderType.replace(/_/g, " ")})
                                                </div>

                                                {/* Order Time */}
                                                <div style={{
                                                    fontWeight: 'bold',
                                                    fontSize: '14px',
                                                    marginBottom: '4px',
                                                    color: isWEB ? 'white' : 'white'
                                                }}>
                                                    Order Time: {order.orderTime}
                                                    {order.tableNo ? ` (Table: ${order.tableNo})` : ''}
                                                </div>

                                                {/* Ready By */}
                                                {isWEB ? (
                                                    <div style={{
                                                        fontWeight: 'bold',
                                                        fontSize: '14px',
                                                        marginBottom: '4px',
                                                        color: 'white'
                                                    }}>
                                                        Ready By: {order.deliveryDateString}
                                                    </div>
                                                ) : (
                                                    <div style={{
                                                        visibility: 'hidden',
                                                        fontWeight: 'bold',
                                                        fontSize: '14px',
                                                        marginBottom: '4px'
                                                    }}>
                                                        Ready By:
                                                    </div>
                                                )}
                                            </div>





                                            <div
                                                style={{
                                                    borderRadius: '8px',
                                                    backgroundColor: '#F9FAFB',
                                                    padding: '12px',
                                                    marginTop: '8px',
                                                    boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                                                }}
                                            >
                                                <DataTable
                                                    data={order.basketDetailKitchenList}
                                                    selectionMode="single"
                                                    rows={5}
                                                    paginator={false}
                                                    fields={OrderItemsForKitchenColumn.fields}
                                                />
                                                {order.basketDetailKitchenList.length > 5 && (
                                                    <div style={{
                                                        marginTop: '10px',
                                                        textAlign: 'center',
                                                        padding: '6px 0'
                                                    }}>
                                                        <button
                                                            onClick={() => this.toggleOrderDetails(order)}
                                                            style={{
                                                                backgroundColor: '#E5E7EB',
                                                                border: '1px solid #D1D5DB',
                                                                borderRadius: '6px',
                                                                padding: '6px 12px',
                                                                fontSize: '13px',
                                                                fontWeight: '500',
                                                                cursor: 'pointer',
                                                                color: '#374151',
                                                            }}
                                                        >
                                                            Show More
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div
                                            style={{
                                                marginTop: '12px',
                                                display: 'flex',
                                                gap: '8px',
                                                flexWrap: 'wrap',
                                                justifyContent: 'space-between',
                                            }}
                                        >
                                            {order.orderStatus === "ORDER_ACCEPTED" && order.basketStatus !== "CANCELLED" && (
                                                <button
                                                    onClick={() => this.preparing(order)}
                                                    style={{
                                                        flex: 1,
                                                        backgroundColor: '#FACC15',
                                                        color: 'black',
                                                        border: 'none',
                                                        borderRadius: '6px',
                                                        padding: '12px',
                                                        fontWeight: 'bold',
                                                        fontSize: '16px',
                                                    }}
                                                >
                                                    Start Preparing
                                                </button>
                                            )}

                                            {order.orderStatus === "ORDER_PREPARING" && (
                                                <button
                                                    onClick={() => this.ready(order)}
                                                    style={{
                                                        flex: 1,
                                                        backgroundColor: '#FACC15',
                                                        color: 'black',
                                                        border: 'none',
                                                        borderRadius: '6px',
                                                        padding: '12px',
                                                        fontWeight: 'bold',
                                                        fontSize: '16px',
                                                    }}
                                                >
                                                    Order Ready
                                                </button>
                                            )}

                                            {order.orderStatus === "ORDER_READY" && (
                                                <button
                                                    onClick={() => this.deliver(order)}
                                                    style={{
                                                        flex: 1,
                                                        backgroundColor: '#FACC15',
                                                        color: 'black',
                                                        border: 'none',
                                                        borderRadius: '6px',
                                                        padding: '12px',
                                                        fontWeight: 'bold',
                                                        fontSize: '16px',
                                                    }}
                                                >
                                                    Deliver Order
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </Fieldset>

                {selectedOrder && (
                    <Dialog
                        visible={displayDialog}
                        onHide={this.closeDisplayDialog}
                        style={GeneralUtils.getDialogStyleKitchenDisplayForDialog()}
                    >
                        <div style={{marginTop: '12px'}}>
                            <DataTableAll
                                data={selectedOrder.basketDetailKitchenList}
                                paginator={false}
                                fields={OrderItemsForKitchenColumn.fields}
                            />
                        </div>
                        <div style={{textAlign: 'left', marginTop: '16px'}}>
                            <button
                                onClick={this.closeDisplayDialog}
                                style={{
                                    backgroundColor: '#6B7280',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '10px',
                                    padding: '16px 24px',
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                    width: '100%',
                                }}
                            >
                                Hide Details
                            </button>
                        </div>
                    </Dialog>
                )}
            </>
        );
    }

    preparing = (order) => {
        if (!GeneralUtils.isNullOrEmpty(order.id)) {
            this.orderService.preparingOrder(order.id).then(() => {
                this.getNewOrders();
            });
        }
    }

    ready = (order) => {
        if (!GeneralUtils.isNullOrEmpty(order.id)) {
            this.orderService.readyOrder(order.id).then(() => {
                this.getNewOrders();
            });
        }
    }

    deliver = (order) => {
        if (!GeneralUtils.isNullOrEmpty(order.id)) {
            this.orderService.deliverOrder(order.id).then(() => {
                this.getNewOrders();
            });
        }
    }

    toggleOrderDetails = (order) => {
        this.setState({
            displayDialog: true,
            selectedOrder: {...order}
        });
    }

    closeDisplayDialog = () => {
        this.setState({displayDialog: false, selectedOrder: null});
    }
}
